import React, { useReducer } from 'react';

import { firestoreInitialize } from 'config/firebase/client';

import PetsContext from './PetsContext';
import PetsReducer from './PetsReducer';

const PetsState = (props) => {
    const initialState = {
        getPets: {
            pets: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPetsByIdCustomer: {
            pets: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getPetsById: {
            pet: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
    };

    const [state, dispatch] = useReducer(PetsReducer, initialState);

    const getPets = (id) => {
        dispatch({ type: 'GET_PETS_LOADING' });

        let db = firestoreInitialize();

        db.collection('Mascotas')
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_PETS', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
        })
        .catch((error) => dispatch({ type: 'GET_PETS_ERROR', payload: { code: 'pets/error', message: error } }))
    };

    const getPetsByIdCustomer = (id) => {
        dispatch({ type: 'GET_PETS_BY_ID_CUSTOMER_LOADING' });

        let db = firestoreInitialize();

        db.collection('Mascotas')
            .where('uid', '==', id)
            .get()
            .then((querySnapshot) => {
                dispatch({ type: 'GET_PETS_BY_ID_CUSTOMER', payload: { data: querySnapshot.docs.map(doc => doc.data()) } })
        })
        .catch((error) => dispatch({ type: 'GET_PETS_BY_ID_CUSTOMER_ERROR', payload: { code: 'pets/error', message: error } }))
    };

    const getPetsById = (id) => {
        dispatch({ type: 'GET_PETS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        db.collection('Mascotas').doc(id)
            .get()
            .then((doc) => {
                dispatch({ type: 'GET_PETS_BY_ID', payload: { data: doc.data() } })
        })
        .catch((error) => dispatch({ type: 'GET_PETS_BY_ID_ERROR', payload: { code: 'pets/error', message: error } }))
    };

    return (
        <PetsContext.Provider value={{
            petsState: state.getPets,
            petsByIdCustomerState: state.getPetsByIdCustomer,
            petsByIdState: state.getPetsById,
            getPets,
            getPetsById,
            getPetsByIdCustomer
        }}>
            {props.children}
        </PetsContext.Provider>
    )
}

export default PetsState;
